import { DisplayMessage } from "../helpers";
import { DeleteRequest, GetRequest, UpdateRequest } from "../requestHelpers";
import { HttpMethods } from "../../utils/constants";
import {
  DeleteAssetClassUrl,
  GetAssetClassesUrl,
  AssetsClassesUrl,
  UpdateAssetClassUrl,
  GetAssetClassByIdUrl,
} from "../../constants/apiUrls";

export const getAssetClasses = async (groupId) => {
  const response = await GetRequest(GetAssetClassesUrl(groupId));
  let result = await response.json();
  if (!response.ok) {
    for (let i = 0; i < result.errors.length; i++) {
      DisplayMessage(result.errors[i], "error");
    }
    return null;
  }
  return result;
};

export const getAssetClassById = async (id) => {
  const response = await GetRequest(GetAssetClassByIdUrl(id));
  let result = await response.json();
  if (!response.ok) {
    for (let i = 0; i < result.errors.length; i++) {
      DisplayMessage(result.errors[i], "error");
    }
    return null;
  }
  return result;
};

export const updateAssetClass = async (id, data) => {
  const response = await UpdateRequest(
    UpdateAssetClassUrl(id),
    data,
    HttpMethods.Patch
  );
  
  let result = await response.json();
  if (!response.ok) {
    for (let i = 0; i < result.errors.length; i++) {
      DisplayMessage(result.errors[i], "error");
    }
    return undefined;
  }
  return result;
};

export const deleteAssetClass = async (id) => {
  const response = await DeleteRequest(DeleteAssetClassUrl(id));

  if (!response.ok) {
    response.json().then((result) => {
      for (let i = 0; i < result.errors.length; i++) {
        DisplayMessage(result.errors[i], "error");
      }
    });
  }

  return response.ok;
};

export const createAssetClass = async (data) => {
  const response = await UpdateRequest(
    AssetsClassesUrl(),
    data,
    HttpMethods.Post
  );
  let result = await response.json();
  if (!response.ok) {
    for (let i = 0; i < result.errors.length; i++) {
      DisplayMessage(result.errors[i], "error");
    }
    return undefined;
  }
  return result;
};
